import type {
  CreateStudent,
  StudentDto,
  StudentsListQuery,
  StudentsListResponse,
  UpdateStudent,
} from '@mm/shared';
import { apiFetch } from './client';

export async function listStudents(q: Partial<StudentsListQuery>): Promise<StudentsListResponse> {
  const params = new URLSearchParams();
  Object.entries(q).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') params.set(k, String(v));
  });
  const res = await apiFetch(`/students?${params.toString()}`);
  if (!res.ok) throw new Error(`listStudents ${res.status}`);
  return res.json();
}

export async function getStudent(id: string): Promise<StudentDto> {
  const res = await apiFetch(`/students/${id}`);
  if (!res.ok) throw new Error(`getStudent ${res.status}`);
  return res.json();
}

export async function createStudent(body: CreateStudent): Promise<StudentDto> {
  const res = await apiFetch('/students', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`createStudent ${res.status}`);
  return res.json();
}

export async function updateStudent(id: string, body: UpdateStudent): Promise<StudentDto> {
  const res = await apiFetch(`/students/${id}`, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`updateStudent ${res.status}`);
  return res.json();
}

export async function deleteStudent(id: string): Promise<void> {
  const res = await apiFetch(`/students/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error(`deleteStudent ${res.status}`);
}

export async function listOnlinePresence(): Promise<{ ids: string[] }> {
  const res = await apiFetch('/students/presence');
  if (!res.ok) throw new Error(`listOnlinePresence ${res.status}`);
  return res.json();
}
